module.exports = __webpack_public_path__ + "img/23.1818771b.png";